import { GetterTree } from "vuex";
import { AuthState } from "@/components/auth/types";
import { RootState } from "@/store/RootState";

export const getters: GetterTree<AuthState, RootState> = {};
